module.exports = __webpack_public_path__ + "static/media/success_1.8905d5b4.gif";